import { Observable } from 'rxjs';
import { IUser } from './iuser.model';

export abstract class UserPermission {
  abstract resolve(): IUser;
  abstract hasEDPWriteAccess(): Observable<boolean> | Promise<boolean>;
  abstract isTrustedUser(): Observable<boolean> | Promise<boolean>;
  abstract hasPermission(groupName: string): Observable<boolean> | Promise<boolean>;
}
